<script>
import { authComputed } from '@state/helpers'
import NavBarRoutes from './nav-bar-routes.vue'

export default {
  components: { NavBarRoutes },
  data() {
    return {
      persistentNavRoutes: [
        {
          name: 'home',
          title: 'Home',
        },
        {
            name: 'editor',
            title: 'Editor',
        },
      ],
      loggedInNavRoutes: [
        {
          name: 'profile',
          title: () => 'Logged in as ' + this.currentUser.name,
        },
        {
          name: 'logout',
          title: 'Log out',
        },
      ],
      loggedOutNavRoutes: [
        // {
        //   name: 'login',
        //   title: 'Log in',
        // },
      ],
    }
  },
  computed: {
    ...authComputed,
  },
}
</script>

<template>
  <div class="row" style="background-color:white;">
    <div class="col-10">
      <div class="text-left float-left mr-5">
        <h4 class="pt-0 mt-1">#MD2DEV PROTOTYPE</h4>
      </div>
      <ul class="text-left float-left mt-1 pt-2" :class="$style.container">
        <NavBarRoutes :routes="persistentNavRoutes" />
      </ul>
    </div>
    <div class="col-2 text-right">
      <ul :class="$style.container">
        <NavBarRoutes v-if="loggedIn" :routes="loggedInNavRoutes" />
        <NavBarRoutes v-else :routes="loggedOutNavRoutes" />
      </ul>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  padding: 0;
  margin: 0 0 $size-grid-padding;
  list-style-type: none;

  > li {
    display: inline-block;
    margin-right: $size-grid-padding;
  }
}
</style>
